import type { FunctionComponent } from 'react';
import React from 'react';

import Form from 'src/components/ui/Form';

import objectOptions from '../../data/objectOptions';
import requestTypeOptions from '../../data/requestTypeOptions';
import subRequestTypeOptions from '../../data/subRequestTypeOptions';
import type { UpdateFieldType } from '../contactForm/ContactForm';
import style from '../contactForm/ContactForm.module.scss';

import type { ContactFormData } from 'src/models/contact';

import { mergeClassNames } from 'src/utils/ReactUtils';

type SubjectContactFormType = {
  updateField: UpdateFieldType;
  formValue: ContactFormData;
  idNetworkBase?: string;
};

const SubjectContactForm: FunctionComponent<SubjectContactFormType> = ({
  updateField,
  formValue,
  idNetworkBase,
}) => {
  return (
    <section className={style.contactForm}>
      <h2 className={style.contactSecondTitle}>pour traîter au mieux...</h2>
      <div
        className={mergeClassNames([style.contactFormContent, 'flex-column'])}
      >
        <Form.Group controlId="requestType">
          <Form.Label
            className={mergeClassNames([
              style.contactFormLabel,
              style.contactFormLabelRequired,
            ])}
          >{`Quel est l'objet de votre demande?`}</Form.Label>
          <Form.Control
            value={formValue.requestType}
            as="select"
            required
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
              updateField(e, Number(e.target.value))
            }
            name="requestType"
          >
            <option value="">Sélectionnez...*</option>
            {requestTypeOptions(Boolean(idNetworkBase)).map(
              (requestTypeOption) => (
                <option key={requestTypeOption.id} value={requestTypeOption.id}>
                  {requestTypeOption.title}
                </option>
              ),
            )}
          </Form.Control>
          <Form.Control.Feedback type="invalid">
            Ce champ est obligatoire.
          </Form.Control.Feedback>
        </Form.Group>
        {formValue.requestType === 1 && (
          <Form.Group controlId="subRequestType">
            <Form.Label
              className={mergeClassNames([
                style.contactFormLabel,
                style.contactFormLabelRequired,
              ])}
            >
              Vous souhaitez
            </Form.Label>
            <Form.Control
              value={formValue.subRequestType}
              as="select"
              required
              onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                updateField(e, Number(e.target.value))
              }
              name="subRequestType"
            >
              <option value="">Sélectionnez...*</option>
              {subRequestTypeOptions.map((requestTypeOption) => (
                <option key={requestTypeOption.id} value={requestTypeOption.id}>
                  {requestTypeOption.title}
                </option>
              ))}
            </Form.Control>
            <Form.Control.Feedback type="invalid">
              Ce champ est obligatoire.
            </Form.Control.Feedback>
          </Form.Group>
        )}
        {[2, 3].includes(formValue.requestType) && (
          <Form.Group controlId="rendezVous">
            <Form.Label
              className={mergeClassNames([
                style.contactFormLabel,
                style.contactFormLabelRequired,
              ])}
            >
              Avez-vous pris rendez-vous sur le site ad.fr ?
            </Form.Label>
            <Form.Check
              inline
              label="Oui"
              value="1"
              checked={formValue.rendezVous === 1}
              name="rendezVous"
              type="radio"
              onChange={(e) => updateField(e, Number(e.target.value))}
            />
            <Form.Check
              inline
              label="Non"
              value="0"
              checked={formValue.rendezVous === 0}
              name="rendezVous"
              type="radio"
              onChange={(e) => updateField(e, Number(e.target.value))}
            />
            <Form.Control.Feedback type="invalid">
              Ce champ est obligatoire.
            </Form.Control.Feedback>
          </Form.Group>
        )}

        {formValue.requestType === 4 && (
          <Form.Group controlId="object">
            <Form.Label
              className={mergeClassNames([
                style.contactFormLabel,
                style.contactFormLabelRequired,
              ])}
            >
              Objet
            </Form.Label>
            <Form.Control
              as="select"
              required
              onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                updateField(e, Number(e.target.value))
              }
              value={formValue.object}
              name="object"
            >
              <option value="">Sélectionnez...*</option>
              {objectOptions.map((objectOption) => (
                <option key={objectOption.id} value={objectOption.id}>
                  {objectOption.title}
                </option>
              ))}
            </Form.Control>
            <Form.Control.Feedback type="invalid">
              Ce champ est obligatoire.
            </Form.Control.Feedback>
          </Form.Group>
        )}
      </div>
      <div className={style.contactFormIndicator}>
        * Ces champs sont obligatoires pour valider votre prise de contact
      </div>
    </section>
  );
};

export default SubjectContactForm;
